module.exports = __webpack_public_path__ + "static/media/megento.85460a67.svg";